// extracted by mini-css-extract-plugin
module.exports = {"options":"Categories_options__1HBP_","flagContainer":"Categories_flagContainer__6S0wP","flag":"Categories_flag__12bSe"};